"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LookupFormatter;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

LookupFormatter.propTypes = _propTypes.EditorProps;

function LookupFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  return /*#__PURE__*/_react["default"].createElement("span", null, Array.isArray(value) ? value.join(", ") : value);
}